// 判断是否为移动端,提高宽度阈值并优化设备检测
export const isMobile = () => {
  // 增加宽度阈值，同时排除平板设备的误判
  const isSmallScreen = window.innerWidth < 1024;
  const isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // 只有同时满足小屏幕和移动设备才判定为移动端
  return isSmallScreen && isMobileDevice;
};
